import { IUser } from 'app/services/user';
import SelectSearchDropDown from 'Components/Form/SearchDropDown/SelectSearchDropDown';

import { optionItemStyle } from 'Components/Select/Options';
import UserBox from 'Components/UserBox';
import { userSearchFilter } from './userSearch';

export default function UserSelectSearch({
  users,
  onSelect,
  skin = 'name',
}: {
  users: IUser[];
  onSelect: (user: IUser) => void;
  skin?: 'box' | 'name';
}) {
  return (
    <SelectSearchDropDown
      disableItemStyle={true}
      value={undefined}
      onChange={onSelect}
      optionItemSkin={(user, isActive) =>
        skin === 'box' ? (
          <UserBox
            size="xs"
            hover="hover:bg-gray-400"
            user={user}
            theme={`${isActive ? 'gray' : 'white'}`}
            px="1"
            py="1"
            shadow=""
            my=""
          />
        ) : (
          <div className={optionItemStyle(isActive)}>
            {user.given_name} {user.family_name}
          </div>
        )
      }
      selectedItemSkin={(i) => <></>}
      searchable={true}
      searchFilter={userSearchFilter}
      clearable={true}
      options={users}
    />
  );
}
